import moment, { Moment } from 'moment';
import { useEffect, useMemo, useState } from 'react';
import { COLORS } from 'src/constants/styles';
import { localeStore } from 'src/mobx/localesStore';
import Label from '~/view/components/Controls/Label';

interface IProps {
  dueTime?: Moment;
  lastStatusDate?: string;
  stop?: boolean;
  className?: string;
}

enum DueTimeStatus {
  left = 'left',
  late = 'late',
}

const DueTime = ({ dueTime, lastStatusDate, stop, className }: IProps): JSX.Element => {
  const [dueTimeStatus, setDueTimeStatus] = useState<DueTimeStatus>(DueTimeStatus.left);
  const [now, setNow] = useState<moment.Moment>(moment());

  // if request has already been processed then we take last status date for difference
  const diff = moment(stop ? lastStatusDate : undefined).diff(moment(dueTime));
  const duration = useMemo(() => moment.duration(diff), [diff]);

  useEffect(() => {
    let interval: NodeJS.Timeout | null = null;

    if (!stop) {
      interval = setInterval(() => setNow(moment()), 1000);
    }

    if (interval && stop) {
      clearInterval(interval);
    }
  }, [stop]);

  useEffect(() => {
    if (diff > 0) {
      setDueTimeStatus(DueTimeStatus.late);
    } else if (dueTimeStatus !== DueTimeStatus.left) {
      setDueTimeStatus(DueTimeStatus.left);
    }
  }, [now, diff, dueTimeStatus]);

  const getColor = () => {
    if (duration.minutes() < 10 && duration.minutes() >= 0 && dueTimeStatus !== DueTimeStatus.late) {
      return COLORS.YELLOW;
    } else if (dueTimeStatus === DueTimeStatus.left) {
      return COLORS.GREEN;
    } else {
      return COLORS.RED;
    }
  };

  const time = moment.utc(duration.abs().asMilliseconds()).format('HH:mm:ss');
  const labelText = `${time} ${localeStore.t(
    dueTimeStatus === DueTimeStatus.left ? localeStore.t('left_delivery_countdown') : localeStore.t('late_delivery_countdown')
  )}`;

  return <Label text={labelText} className={`due-time family-semibold ml-3 letter-spacing-5 ${className || ''}`} color={getColor()} />;
};

export default DueTime;
